import { render, staticRenderFns } from "./claimResponsibilityConfirmList.vue?vue&type=template&id=56322ba4&scoped=true"
import script from "./claimResponsibilityConfirmList.vue?vue&type=script&lang=js"
export * from "./claimResponsibilityConfirmList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./claimResponsibilityConfirmList.vue?vue&type=style&index=1&id=56322ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56322ba4",
  null
  
)

export default component.exports